export default {"src":"/customer-services/_next/static/media/headset.ad533d8f.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};